import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styled from 'styled-components'

const Card = styled.div`
    display: flex;
    cursor: pointer;
    align-items: center;
    margin-top: 2rem;
    padding-left: 1.2rem;
    margin-right: 1rem;
    background-color: white;
    box-shadow:  0 0 5px rgba(146, 146, 146, 0.192);
    width: 40%;
    height:90px;
    border-radius: 20px;

    p{
        color: rgb(57, 57, 57);
        font-family: "Poppins";
        font-weight: 600;
        font-size: 1.2rem;
        height: 15px;
    }

    @media screen and (max-width:720px){
        width: 100%;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 0px;
        padding-left: 0rem;
        p{
            margin-top: 0.3rem;
            text-align: center;
            height: 0px;
            font-size:0.9rem;
        }

        div{
            margin: 0 auto;
        }
        
    }

`
const Box = styled.div`
    margin-left: 0.9rem;
    display: flex;
    flex-direction: column;

`
const BoxImage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f4f7fe;
    width: 50px;
    height: 50px;
    border-radius: 100px;
    svg{
        width: 60px;
        height: 32px;
    }

    @media screen and (max-width:720px){
    
        
    }

`

const DashboardGrafical = ({ name, backgroundColor, type, value,width,marginTop,onClick,change }) => {
    return (

        <Card onClick={onClick} style={{ backgroundColor: backgroundColor,width:width,marginTop:marginTop,border:change == 1  & type == 3 ? "2px solid #FFF898" : change == 2 & type == 2? "2px solid #0A906E" :""}}>
            <BoxImage>
                {type == 1
                    ?
                    <svg stroke="currentColor" fill="#422afb" stroke-width="0" viewBox="0 0 24 24" class="h-7 w-7" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>

                    :
                    type == 2

                        ?
                        <svg stroke="currentColor" fill="#422afb" stroke-width="0" viewBox="0 0 24 24" class="h-6 w-6" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"></path></svg>
                        :
                        <svg stroke="currentColor" fill="#422afb" stroke-width="0" viewBox="0 0 24 24" class="h-7 w-7" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>
                }
            </BoxImage>
            <Box>
                <p>{name}</p>
                {type == 1

                    ?

                    value != undefined

                        ?
                        <p>{value}</p>
                        :
                        <Skeleton width={"100%"} />

                    :
                    value != undefined

                        ?
                        <p>{value}</p>

                        :
                        <Skeleton width={"100%"} />


                }
            </Box>


        </Card>

    )
}

export default DashboardGrafical